export default "__VITE_ASSET__CyuzdLca__"